import React from 'react';

// @ts-ignore: TS2459 — we know it's there at runtime
import { PerformanceChartsSection } from '@PikaDoApp/pikado-web-dsm';
import {PastMonthlyAverage} from "@PikaDoApp/npm-pikado-logic"


interface StudentPerformanceChartsContainerProps {
  monthlyAverage:number
  selectedMonth: string;
  historicalPerformanceData:PastMonthlyAverage[];
  onMonthChange: (month: string) => void;
  monthOptions: Array<{label: string; value: string}>;
}

export const StudentPerformanceChartsContainer: React.FC<StudentPerformanceChartsContainerProps> = ({
  monthlyAverage,
  historicalPerformanceData,
  selectedMonth,
  onMonthChange,
  monthOptions,
}) => {


  return (
    <PerformanceChartsSection
      averagePercentage={monthlyAverage}
      historicalPerformanceData={historicalPerformanceData}
      monthOptions={monthOptions}
      selectedMonth={selectedMonth}
      onMonthChange={onMonthChange}
      donutTitle="Monthly Performance"
      areaChartTitle="Previous Months Performance"
      areaChartFillColor="rgba(116, 187, 231, 0.75)"
      areaChartStrokeColor="#74BBE7"
    />
  );
};
